module.exports = __webpack_public_path__ + "fonts/DB Heavent v3.2.b5c8bc60.ttf";